import { CoSyncInfo, CoSyncSetting } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';
import { OperateTaskInfo } from '@/workerProcessRenderer/scripts/CoSyncEngine/Operator/typings';

/**
 *
 *
 * @export
 * @enum {number}
 * 同步服务对象支持的命令
 */
export enum CmdTypeFromRender {
  START = 'START',
  STOP = 'STOP',
  TURN_ON_ENGINE = 'TURN_ON_ENGINE',
  TURN_OFF_ENGINE = 'TURN_OFF_ENGINE',
  DESTORY = 'DESTORY',
  CONFLICT_RESOLVE = 'CONFLICT_RESOLVE',
  FETCH_OPERATE_TASK_LIST = 'FETCH_OPERATE_TASK_LIST',
  START_LISTEN_OPERATE_TASK = 'START_LISTEN_OPERATE_TASK',
  STOP_LISTEN_OPERATE_TASK = 'STOP_LISTEN_OPERATE_TASK',
  QUERY_HISTORY = 'QUERY_HISTORY',
  CLEAR_HISTORY = 'CLEAR_HISTORY',
  UPDATE_CO_SYNC_INFO = 'UPDATE_CO_SYNC_INFO',
  UPDATE_CO_SYNC_SETTING = 'UPDATE_CO_SYNC_SETTING',
}

export interface CmdFromRenderer {
  cmdType: CmdTypeFromRender;
  param?: unknown;
}

export type StartCmdparam = {
  isFromUIAction: boolean;
};

export type TurnOffEngineCmdParam = {
  isSilent: boolean;
};

export type StopCmdParam = {
  isFromUIAction: boolean;
  isSilent?: boolean;
};

export type QueryHistoryType = 'below' | 'above';
export type QueryHistoryCmdParam = {
  historyId?: number;
  queryType?: QueryHistoryType;
  count: number;
};

export type DestoryCmdParam = {
  isPermanent: boolean;
};

export type UpdateCoSyncInfoParam = {
  coSyncInfo: CoSyncInfo;
};

export type UpdateCoSyncSettingParam = {
  coSyncSetting: CoSyncSetting;
};

export type FetchOperateTaskListParam = {
  firstNormalN: number;
  firstExceptionN: number;
};

export type FetchOperateTaskListResult = {
  allCount: number;
  finishCount: number;
  exceptionCount: number;
  taskInfoList: OperateTaskInfo[];
};
